import { IconButton, PinIcon, UnpinIcon } from "@minervaproject/fds";
import clsx from "clsx";
import React from "react";

import { useAppDispatch } from "hooks/redux_hooks";
import { setBreakoutRoomIsPinned } from "shared/reducers/classroom";
import { BreakoutRoomType } from "shared/types";

import "./pin_button.scss";

function PinButton({
  breakoutRoom,
  pinButtonText,
  unpinButtonText,
  buttonTextClassName,
  noPadding = false,
}: {
  breakoutRoom: BreakoutRoomType;
  pinButtonText?: string;
  unpinButtonText?: string;
  buttonTextClassName?: string;
  noPadding?: boolean;
}) {
  const dispatch = useAppDispatch();

  const togglePinBreakoutRoom = (isPinned: boolean) => () => {
    dispatch(setBreakoutRoomIsPinned({ breakoutRoomId: breakoutRoom.id, isPinned }));
  };

  return breakoutRoom.is_pinned ? (
    <IconButton
      onClick={togglePinBreakoutRoom(false)}
      aria-label={`Unpin Breakout Group ${breakoutRoom.title}`}
      className={noPadding ? "pin-button-p0" : undefined}
    >
      <UnpinIcon width={16} height={16} color="white" />
      {unpinButtonText && (
        <span className={clsx("ml1", buttonTextClassName)}>{unpinButtonText}</span>
      )}
    </IconButton>
  ) : (
    <IconButton
      onClick={togglePinBreakoutRoom(true)}
      aria-label={`Pin Breakout Group ${breakoutRoom.title}`}
      className={noPadding ? "pin-button-p0" : undefined}
    >
      <PinIcon width={16} height={16} color={pinButtonText ? "white" : undefined} />
      {pinButtonText && <span className={clsx("ml1", buttonTextClassName)}>{pinButtonText}</span>}
    </IconButton>
  );
}

export { PinButton };
